import Vue from 'vue'
import Router from 'vue-router'
//登录页面
import Login from '@/components/login/login'
//首页
import Index from '@/components/index/index'
import Activity from '@/components/index/activity'
import Investigate from '@/components/index/investigate'
//体检服务首页
import PhyExServices from '@/components/phyExServices/phyExServices'
//早鸟计划
import earlyBird from '@/components/phyExServices/earlyBird'

//员工体检--家属体检
import WriteSubscribe from '@/components/phyExServices/selfPhyExService/writeSubscribe'
import familyMembers from '@/components/phyExServices/selfPhyExService/familyMembers'
import SetMealDetails from '@/components/phyExServices/selfPhyExService/setMealDetails'
import HospitalDetails from '@/components/phyExServices/selfPhyExService/hospitalDetails'
import PhyAckOrder from '@/components/phyExServices/selfPhyExService/phyAckOrder'
import SuccessfulAppointment from '@/components/phyExServices/selfPhyExService/successfulAppointment'
//体检订单
import PhyOrderList from '@/components/phyExServices/orderList/list'
import PhyOrderDetails from '@/components/phyExServices/orderList/details'
//体检报告
import MedicalReports from '@/components/phyExServices/medicalReports/list'
import ReportImg from '@/components/phyExServices/medicalReports/reportImg'
import Appraise from '@/components/phyExServices/medicalReports/appraise'
//在线咨询
import OnlineConsulting from '@/components/phyExServices/onlineConsulting/index'
//投诉建议
import Suggestions from '@/components/phyExServices/suggestions/index'
//个人中心
import suggestions1 from '@/components/phyExServices/suggestions1'
import Personal from '@/components/personal/personal'
import IntegralDetails from '@/components/personal/integralDetails'
import AccountSecurity from '@/components/personal/accountSecurity'
//pdf
import Pdf from '@/components/pdf/pdf.vue';

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'Login',
            component: Login,
            meta: {
                title: '登录'
            }
        },
        {
            path: '/index',
            name: 'Index',
            component: Index,
            meta: {
                title: '首页',
                requireAuth: true
            }
        }, {
            path: '/familyMembers',
            name: 'familyMembers',
            component: familyMembers,
            meta: {
                title: '家属体检',
                requireAuth: true
            }
        }, {
            path: '/activity',
            name: 'Activity',
            component: Activity,
            meta: {
                title: '早鸟计划',
                requireAuth: true
            }
        },
        {
            path: '/suggestions1',
            name: 'suggestions1',
            component: suggestions1,
            meta: {
                title: '投诉建议',
                requireAuth: true
            }
        },
        {
            path: '/investigate',
            name: 'Investigate',
            component: Investigate,
            meta: {
                title: '满意度调查',
                requireAuth: true
            }
        },
        {
            path: '/earlyBird',
            name: 'earlyBird',
            component: earlyBird,
            meta: {
                title: '早鸟计划',
                requireAuth: true
            }
        },
        {
            path: '/phyExServices',
            name: 'PhyExServices',
            component: PhyExServices,
            meta: {
                title: '体检服务',
                requireAuth: true
            }
        },
        {
            path: '/personal',
            name: 'Personal',
            component: Personal,
            meta: {
                title: '个人中心',
                requireAuth: true
            }
        },
        {
            path: '/integralDetails',
            name: 'IntegralDetails',
            component: IntegralDetails,
            meta: {
                title: '额度使用明细',
                requireAuth: true
            }
        },
        {
            path: '/accountSecurity',
            name: 'AccountSecurity',
            component: AccountSecurity,
            meta: {
                title: '账户安全',
                requireAuth: true
            }
        },
        {
            path: '/writeSubscribe',
            name: 'WriteSubscribe',
            component: WriteSubscribe,
            meta: {
                title: '填写预约信息',
                requireAuth: true,
                isBack: false,
                keepAlive: true //组件需要被缓存
            }
        },
        {
            path: '/setMealDetails',
            name: 'SetMealDetails',
            component: SetMealDetails,
            meta: {
                title: '员工体检-套餐详情',
                requireAuth: true
            }
        },
        {
            path: '/hospitalDetails',
            name: 'HospitalDetails',
            component: HospitalDetails,
            meta: {
                title: '员工体检-分院详情',
                requireAuth: true
            }
        },
        {
            path: '/phyAckOrder',
            name: 'PhyAckOrder',
            component: PhyAckOrder,
            meta: {
                title: '订单确认',
                requireAuth: true,
                isBack: false,
                keepAlive: true //组件需要被缓存
            }
        },
        {
            path: '/middlePage',
            name: 'middlePage',
            component: () =>
                import ("@/components/phyExServices/selfPhyExService/middlePage"),
            meta: {
                title: '预约中',
                requireAuth: true
            }
        },
        {
            path: '/errorAppointment',
            name: 'errorAppointment',
            component: () =>
                import ("@/components/phyExServices/selfPhyExService/errorAppointment"),
            meta: {
                title: '预约失败',
                requireAuth: true
            }
        },
        {
            path: '/middlePageTeeth',
            name: 'middlePageTeeth',
            component: () =>
                import ("@/components/phyExServices/selfPhyExService/middlePageTeeth"),
            meta: {
                title: '预约申请',
                requireAuth: true
            }
        },
        {
            path: '/successfulAppointment',
            name: 'SuccessfulAppointment',
            component: SuccessfulAppointment,
            meta: {
                title: '预约成功',
                requireAuth: true
            }
        },
        {
            path: '/phyOrderList',
            name: 'PhyOrderList',
            component: PhyOrderList,
            meta: {
                title: '体检订单',
                requireAuth: true,
                isBack: false,
                keepAlive: true //组件需要被缓存
            }
        },
        {
            path: '/phyOrderDetails',
            name: 'PhyOrderDetails',
            component: PhyOrderDetails,
            meta: {
                title: '体检订单详情',
                requireAuth: true
            }
        },
        {
            path: '/medicalReports',
            name: 'MedicalReports',
            component: MedicalReports,
            meta: {
                title: '体检报告',
                requireAuth: true
            }
        },
        {
            path: '/reportImg',
            name: 'ReportImg',
            component: ReportImg,
            meta: {
                title: '查看体检报告',
                requireAuth: true
            }
        },
        {
            path: '/appraise',
            name: 'Appraise',
            component: Appraise,
            meta: {
                title: '疾病风险评估',
                requireAuth: true
            }
        },
        {
            path: '/onlineConsulting',
            name: 'OnlineConsulting',
            component: OnlineConsulting,
            meta: {
                title: '在线咨询',
                requireAuth: true
            }
        },
        {
            path: '/suggestions',
            name: 'Suggestions',
            component: Suggestions,
            meta: {
                title: '投诉建议',
                requireAuth: true
            }
        },
        {
            path: '/pdf',
            name: 'Pdf',
            component: Pdf,
            meta: {
                title: 'pdf'
            }
        },
        {
            path: '/reimburse',
            name: 'reimburse',
            component: () =>
                import ("../views/reimburse"),
            meta: {
                title: '在线报销',
                requireAuth: true,
            }
        },
        {
            path: '/noticeDetail',
            name: 'noticeDetail',
            component: () =>
                import ("../views/noticeDetail"),
            meta: {
                title: '企业报销须知详情',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/billConfirm',
            name: 'billConfirm',
            component: () =>
                import ("../views/billConfirm"),
            meta: {
                title: '在线报销-信息确认',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/reimburseSuccess',
            name: 'reimburseSuccess',
            component: () =>
                import ("../views/reimburseSuccess"),
            meta: {
                title: '在线报销-申请提交成功',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/exportFile',
            name: 'exportFile',
            component: () =>
                import ("../views/exportFile"),
            meta: {
                title: '在线报销-导出报销单',
                requireAuth: true,
            }
        },
        {
            path: '/dispatchList',
            name: 'dispatchList',
            component: () =>
                import ("../views/dispatchList"),
            meta: {
                title: '报销单列表',
                requireAuth: true,
            }
        },
        {
            path: '/dispatchDetail',
            name: 'dispatchDetail',
            component: () =>
                import ("../views/dispatchDetail"),
            meta: {
                title: '报销单详情',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/declarationInformation',
            name: 'declarationInformation',
            component: () =>
                import ("../views/declarationInformation"),
            meta: {
                title: '填写申报信息',
                requireAuth: true,
            }
        },
        {
            path: '/afterMarket/index',
            name: 'afterMarket',
            component: () =>
                import ("@/components/afterMarket/index"),
            meta: {
                title: '售后服务',
                requireAuth: true,
                id: 2,
            }
        },
        {
            path: '/afterMarket/applyFor',
            name: 'applyFor',
            component: () =>
                import ("@/components/afterMarket/applyFor"),
            meta: {
                title: '申请售后',
                requireAuth: true,
                id: 2,
            }
        },
        {
            path: '/afterMarket/detail',
            name: 'afterMarketDetail',
            component: () =>
                import ("@/components/afterMarket/detail"),
            meta: {
                title: '售后单详情',
                requireAuth: true,
                id: 2,
            }
        },
        {
            path: '/afterMarket/edit',
            name: 'afterMarketEdit',
            component: () =>
                import ("@/components/afterMarket/edit"),
            meta: {
                title: '售后单详情',
                requireAuth: true,
                id: 2,
            }
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js